export default "__VITE_ASSET__e39115c7__"